<template>
    <a-card :bordered="false">
        <a-form layout='inline'>
           <a-form-item label="日期">
               <a-select v-model:value="search.search_date_type" style="width: 120px" ref="select" @change="handleChange">
                  <a-select-option :value="1">日</a-select-option>
                  <a-select-option :value="2">自然周</a-select-option>
                  <a-select-option :value="3">自然月</a-select-option>
                  <a-select-option :value="4">近7天</a-select-option>
                  <a-select-option :value="5">自定义时间</a-select-option>
                </a-select>
           </a-form-item>
           <a-form-item label="">
               <!-- <a-date-picker v-model:value="search.search_time" :disabledDate="disabledDate" v-if="search.search_date_type=='1'" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' />
               <a-week-picker v-else-if="search.search_date_type=='2'" :disabledDate="disabledDate" @change="changeWeek" v-model:value="weekTime" />
               <a-month-picker v-model:value="search.search_time" v-else-if="search.search_date_type=='3'"  :disabledDate="disabledDate" valueFormat='YYYY-MM' format='YYYY-MM' />
               <a-range-picker v-if="search.search_date_type=='5'" v-model:value="time" :disabledDate="disabledDate" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' style="width:300px"/>
                -->
                  <a-date-picker v-model:value="search.search_time" :disabledDate="disabledDate" v-if="search.search_date_type=='1'" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' />
                <a-week-picker v-else-if="search.search_date_type=='2'" :disabledDate="disabledDate" @change="changeWeek" v-model:value="weekTime" />
                <a-month-picker v-model:value="search.search_time" v-else-if="search.search_date_type=='3'"  :disabledDate="disabledDate" valueFormat='YYYY-MM' format='YYYY-MM' />
               <a-range-picker v-if="search.search_date_type=='5'" v-model:value="time" :disabledDate="disabledDate" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' style="width:300px"/>
           </a-form-item>
           <a-form-item label="礼品名称" class="s_po_re">
               <a-input v-model:value="search.gift_name" readonly placeholder="请选择礼品" style="width:180px"></a-input>
                <CloseCircleOutlined v-if="search.gift_name" class="CloseCircleOutlined s_shou" @click="clearVal"/>
           </a-form-item>
           <a-form-item>
               <a-button type="primary" @click="showGift=true">选择</a-button>
           </a-form-item>
           <a-form-item>
               <a-button type="primary" @click="onSearch">搜索</a-button>
           </a-form-item>
        </a-form>

        <div class="m-t-20">
            <a-spin :spinning="spinning">
             <echartLine :echartsData='echartData' v-if="!spinning" ></echartLine>
            </a-spin>
        </div>
        <div>
            <h4 class="fz-15 s_font_b m-b-20">兑换明细</h4>
            <a-table :pagination='pagination' :loading='listLoading' bordered :columns='columns' :data-source='list' @change="changePage">
                <template v-slot:good="{record}">
                     <div >
                           <a-card-meta>
                             <template #avatar>
                               <img :src="info.picdomain+'/'+(record.gift_image)" alt="" style="width:50px;height:50px">
                             </template>
                             <template #description>
                               <p class="s_omit2" style="width: 320px;">{{record.gift_name}}</p>
                             </template>
                           </a-card-meta>
                     </div>
                 </template>
            </a-table>
        </div>
       <!-- 选择礼品 -->
        <a-modal :keyboard="false" title="选择礼品" v-model:visible="showGift" centered :width='1000' :footer="null" destroyOnClose>
          <!-- <selectBaseGiftSku :checkout="false" v-on:select="giftSelect" /> -->
          <selectGiftSku v-on:select="giftSelect" :selectList='selectList'></selectGiftSku>
        </a-modal>
    </a-card>
</template>
<script>
import {giftStatisticsList} from '@/api/guide';
import {CloseCircleOutlined} from '@ant-design/icons-vue';
import { ref,reactive, toRefs, onMounted } from 'vue'
import moment from 'moment';
import store from "@/store";
import selectGiftSku from './components/select_gift'
import { useTime } from "@/hooks/utils/useTime";
import { iscode } from '../../../../utils/app';
import { message } from 'ant-design-vue';
const columns = [
    {
      title: "礼品信息",
      dataIndex: "gift_name",
      key: "gift_name",
      slots: { customRender: "good" },
    },
    {
      title: "规格",
      dataIndex: "gift_sku_name",
      key: "gift_sku_name",
    },
    {
      title: "分类",
      dataIndex: "gift_category_name",
      key: "gift_category_name",
    },
    {
      title: "兑换数量",
      dataIndex: "exchange_num",
      key: "exchange_num",
    },
    {
      title: "支付积分",
      dataIndex: "point_num",
      key: "point_num",
    },
    {
      title: "支付金额",
      dataIndex: "pay_price",
      key: "pay_price",
    },
]
export default{
    components:{CloseCircleOutlined,selectGiftSku},
    setup(){
      const { dateTargets, typeToStartEnd } = useTime();
        const search = ref({
            gift_name:'',
            gift_id:'',
            search_date_type:1,
            search_time:'',
            start_time:'',
            end_time:'',
            page:1,
            limit:10
        })
         const dateTime = reactive({
              dayTime: "",
              weekTime: "",
              monthTime: "",
              quarterTime: "",
              time: [],
            });
         const state = reactive({
               info: store.state.user.info,
               disabledDate:function(current) {
                  return current && current > moment().subtract(0, 'days').endOf('day')
                },
                pagination:{ 
                 total:0,
                 current:1,
                 pageSize:10,
                 defaultPageSize:10,
                 showSizeChanger:true,
                 pageSizeOptions:['10', '20', '30', '40', '50'], 
                 showQuickJumper:true, 
                 showTotal:(total)=> `共 ${total} 条`,
               },
                spinning:false,
                listLoading:false,
                list:[],
                line:{},
                selectList:[],
                echartData:{
                    titleName:'兑换概览',
                    dataName:['兑换数'],
                    latelyDays:[],
                    series: []
                },
                showGift:false
         })

         const getTable = async () => {
             switch (search.value.search_date_type) {
               case 1:
                 search.value.end_time = search.value.search_time;
                 search.value.start_time = search.value.search_time;
                 break;
               case 2:
                 search.value.start_time = search.value.search_time.split(",")[0];
                 search.value.end_time = search.value.search_time.split(",")[1];
                 break;
               case 3:
                 search.value.start_time = moment(search.value.search_time)
                   .startOf("month")
                   .format("YYYY-MM-DD");
                 search.value.end_time = moment(search.value.search_time)
                   .endOf("month")
                   .format("YYYY-MM-DD");
                 break;
                 case 5:
                   search.value.search_time = dateTime.time;
                   search.value.start_time = dateTime.time[0]
                   search.value.end_time = dateTime.time[1]
             }
           };

         const methods ={
             changeWeek(){},
             handleChange(e){
                     search.value.search_time = "";
                     switch (e) {
                       case 1:
                         search.value.search_time = typeToStartEnd("1").start_time;
                         search.value.end_time = typeToStartEnd("1").end_time;
                         search.value.start_time = typeToStartEnd("1").start_time;
                         break;
                       case 2:
                         search.value.start_time = typeToStartEnd("7").start_time;
                         search.value.end_time = typeToStartEnd("7").end_time;
                         search.value.search_time = typeToStartEnd("7").start_time + "," + typeToStartEnd("7").end_time;
                         dateTime.weekTime = typeToStartEnd("week").end_time;
                         break;
                       case 3:
                         search.value.search_time = dateTargets("month");
                         search.value.start_time = typeToStartEnd("month").start_time;
                         search.value.end_time = typeToStartEnd("month").end_time;
                         break;
                       case 4:
                         search.value.search_time = typeToStartEnd("1").start_time;
                         search.value.end_time = typeToStartEnd("1").end_time;
                         search.value.start_time = typeToStartEnd("7").start_time;
                         break;
                     }
             },
             giftSelect(e){
               state.selectList = [e];
               search.value.gift_name = e.gift_name;
               search.value.gift_id = e.gift_id;
                 console.log(e)
                 state.showGift = false;
             },
             clearVal(){
               search.value.gift_name ="";
               search.value.gift_id =  "";
             },
             onSearch(){
               getTable()
               search.value.page = 1;
               state.pagination.current = 1;
               methods.getGiftStatisticsList()
             },
             async getGiftStatisticsList(){
                  state.listLoading = true;
                 state.spinning = true;
                state.list = [];
                let res = await giftStatisticsList({...search.value}).then(res=>res.data);
                state.listLoading = false;
                if(iscode(res)){
                   state.list = res.data.list.data || [];
                   state.pagination.total = res.data.list.total;
                   state.echartData={
                         titleName:'兑换概览',
                         dataName:['兑换数'],
                         latelyDays: res.data.line.date || [],
                         series: [{
                                   data: res.data.line.exchange_num || [],
                                   type: 'line',
                                    symbolSize: 6,
                                     smooth: true,
                                     name:'兑换数'
                                 }]
                     }
                       state.spinning = false;
                }else{
                   state.spinning = false;
                  message.error(res.msg)
                }
             },
              changePage(e){
                 state.pagination.current = e.current;
                 state.pagination.pageSize = e.pageSize;
                 search.value.page = e.current;
                 search.value.limit = e.pageSize;
                 methods.getGiftStatisticsList()
             }
         }
         onMounted(()=>{
           methods.handleChange(1)
           methods.getGiftStatisticsList()
         })

        return {
            search,
            ...toRefs(dateTime),
            ...toRefs(state),
            ...methods,
            columns
        }
    }
}
</script>

<style lang="less" scoped>
.CloseCircleOutlined{
    position: absolute;
    top:50%;
    right:8px;
    transform: translateY(-50%);
}
</style>
